import initDatadogClientside from "@/app/observability";
import { IS_LOCAL } from "@/config";
import { setupServerActionMismatchRecovery } from "@/lib/errors/server-action-mismatch-recovery";
import { datadogLogs } from "@datadog/browser-logs";
import { initOpenFeatureProvider } from "@/lib/openfeature/init";

// Local dev never sends RUM/log events (see beforeSend checks in
// observability.tsx), but datadogRum.init()/datadogLogs.init() still stand up
// session replay recording, resource/long-task observers, and a live
// DatadogProvider network connection for OpenFeature — real per-navigation
// browser overhead for no local benefit. Skip entirely, mirroring the
// IS_LOCAL guard around tracer init in instrumentation.ts.
if (!IS_LOCAL) {
  initDatadogClientside();
  // Initialize after RUM so the DatadogProvider can piggyback on the existing RUM instance
  initOpenFeatureProvider();
}

setupServerActionMismatchRecovery({
  onRecoveryAttempt: (context) => {
    datadogLogs.logger.warn(
      "Refreshing page after server action deployment mismatch",
      context,
    );
  },
  onRecoverySkipped: (context) => {
    const message =
      context.reason === "already_attempted"
        ? "Skipped server action mismatch refresh; already attempted in this tab"
        : "Skipped server action mismatch refresh; sessionStorage unavailable";

    datadogLogs.logger.warn(message, context);
  },
});
